import React from "react";
import Sidebar from "../../components/Sidebar";
import GiftCardBuyOrdersTable from "./components/GiftCardBuyOrdersTable";

const GiftCardBuyOrders = () => {
  return (
    <div className="flex overflow-hidden flex-col h-screen md:flex-row">
      <Sidebar />

      <div className="overflow-y-auto flex-1 p-4 bg-white md:py-7">
        <h1 className="py-4 mb-0 text-xl font-bold md:text-2xl md:mb-6">Gift Card Buy Orders</h1>

        <div className="">
          <GiftCardBuyOrdersTable />
        </div>
      </div>
    </div>
  );
};

export default GiftCardBuyOrders;
